/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const onboardingDataAction = createAction('REFORAL_ONBOARDING_DATA_ACTION');
export const getSpecialtiesAction = createAction('REFORAL_GET_SPECIALTIES');
export const getServicesAction = createAction('REFORAL_GET_SERVICES');
export const getAllergiesAction = createAction('REFORAL_GET_ALLERGIES');
export const getSpecialConsiderationsAction = createAction('REFORAL_GET_SPECIAL_CONSIDERATIONS');
export const getSedationsAction = createAction('REFORAL_GET_SEDATIONS');
export const getProvincesAction = createAction('REFORAL_GET_PROVINCES');
export const sendInvitationAction = createAction('REFORAL_SEND_INVITATION');
export const getSpecialtiesAndServicesAction = createAction('REFORAL_GET_SPECIALTIES_AND_SERVICES');
export const getUnreadNotificationsAction = createAction('REFORAL_GET_UNREAD_NOTIFICATIONS');
export const getLabServicesAction = createAction('REFORAL_GET_LABORATORY_SERVICES');
